export default __webpack_public_path__ + "static/media/bl_1.e0a9b6c9.jpg";